import { FlosIcon, InfoBox } from '@flos/react-ui';
import { useHippoText } from '../../../../hooks/useHippoText';
import type { CarOnsaDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/motor';

function convertEngineSize(engineSize: number): string {
    if (engineSize === 0) {
        return '';
    }
    const divided = engineSize / 1000;
    const withDecimal = divided.toFixed(1);
    const result = withDecimal.replace(/\./g, ',') + 'L';
    return result;
}
const CarInfoBox = ({
    isVehicleFound,
    coverable
}: {
    isVehicleFound: boolean | undefined;
    coverable: CarOnsaDTO;
}): React.JSX.Element => {
    const getHippoText = useHippoText();

    const getInfoBoxLabel = (): string => {
        if (isVehicleFound) {
            return getHippoText('DSS-COVERABLE-INFORMATION-STEP-REGISTRATION-PLATE-VEHICLE-TYPE');
        } else if (isVehicleFound === undefined) {
            return '';
        }
        return getHippoText('DSS-COVERABLE-INFORMATION-STEP-REGISTRATION-PLATE-NOT-FOUND');
    };
    const make: string = coverable.make ?? '';
    const model: string = coverable.model ?? '';
    const engineSize: number = coverable.engineSize ?? 0;
    const convertedEngineSize = convertEngineSize(engineSize);

    const getInfoBoxTitle = (): string => {
        if (isVehicleFound) {
            return `${make} ${model} ${convertedEngineSize}`;
        } else if (isVehicleFound === undefined) {
            return '';
        }
        return getHippoText('DSS-COVERABLE-INFORMATION-STEP-REGISTRATION-PLATE-NOT-FOUND-CHECK');
    };

    return (
        <InfoBox
            className="u-spacing-inset-bottom-4"
            iconShape={'car-van-side'}
            label={getInfoBoxLabel()}
            title={getInfoBoxTitle()}
            text={isVehicleFound ? coverable.variant : ''}
            actionArea={
                isVehicleFound !== undefined && (
                    <FlosIcon
                        className={isVehicleFound ? 'is-green has-fill' : 'is-red has-fill'}
                        shape={isVehicleFound ? 'circle-check' : 'circle-close'}
                        size={'medium'}
                    />
                )
            }
        />
    );
};

export default CarInfoBox;
